import { render, staticRenderFns } from "./card-media.vue?vue&type=template&id=74f0b9c0&scoped=true&"
import script from "./card-media.vue?vue&type=script&lang=js&"
export * from "./card-media.vue?vue&type=script&lang=js&"
import style0 from "./card-media.vue?vue&type=style&index=0&id=74f0b9c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f0b9c0",
  null
  
)

export default component.exports